import React from 'react';
import Button, { BOOKING_HREF } from '../Button/Button';
import './Hero.css';
import heroWave from '../../assets/waves/Shape hero.svg';
import heroBg from '../../assets/hero/landscape-design-roaring-fork-valley-colorado.png';
const stats = [
  { value: '20+', label: 'Years of experience' },
  { value: '500+', label: 'Projects Done' },
  { value: 'A+', label: 'BBB Accredited' },
];

const Hero = () => (
  <section className="hero">
    <div className="hero__bg">
      <img src={heroBg} alt="Landscaped backyard Roaring Fork Valley Colorado" className="hero__bg-img" />
      <div className="hero__overlay" />
    </div>
    <h1 className="hero__seo-heading">
      Landscape Design &amp; Maintenance | Roaring Fork Valley Colorado - Aspen, Carbondale, Basalt, Glenwood Springs, New Castle
    </h1>
    <div className="hero__inner">
      <div className="hero__content">
        <div className="hero__eyebrow">
          <span className="hero__eyebrow-line" />
          <span className="hero__eyebrow-text">Landscape Design &amp; Maintenance · Aspen to Glenwood Springs, CO</span>
        </div>
        <h1 className="hero__heading">
          <span className="hero__heading-white">Your yard.</span>
          <span className="hero__heading-accent">Finally yours.</span>
        </h1>
        <p className="hero__body">We design, build, and maintain outdoor spaces that people actually love living in. You tell us what you dream of, and we take care of every single detail. From the first conversation to the finished yard, and everything in between.</p>
        <div className="hero__ctas">
          <Button variant="primary" href={BOOKING_HREF}>Get a Free Consultation</Button>
          <Button variant="secondary" href="#services">Explore our services →</Button>
        </div>
        <div className="hero__stats">
          {stats.map(stat => (
            <div key={stat.label} className="hero__stat">
              <strong className="hero__stat-value">{stat.value}</strong>
              <span className="hero__stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
    <img src={heroWave} alt="" className="hero__wave" />
  </section>
);

export default Hero;
